import { render } from "./apple.svg?vue&type=template&id=54da23e1"
const script = {}
script.render = render

export default script